import { EMPTY_STRING } from '../../../constants/common'
import { normalizeHtml } from '../../../utils/html'
import { formValidationSchemaNoChanged } from '../../Form'

import { REQUEST_EDIT_DESCRIPTION_MODAL_FIELD_NAME } from './RequestEditDescriptionModal.constants'

function getRequestEditDescriptionModalComparableValue(value) {
  return normalizeHtml(value || EMPTY_STRING)
}

function isRequestEditDescriptionModalFormFieldsEqual({
  initialValues,
  values,
}) {
  return (
    getRequestEditDescriptionModalComparableValue(
      initialValues?.[REQUEST_EDIT_DESCRIPTION_MODAL_FIELD_NAME]
    ) ===
    getRequestEditDescriptionModalComparableValue(
      values?.[REQUEST_EDIT_DESCRIPTION_MODAL_FIELD_NAME]
    )
  )
}

export function getRequestEditDescriptionModalInitialValues(value) {
  return {
    [REQUEST_EDIT_DESCRIPTION_MODAL_FIELD_NAME]: value || EMPTY_STRING,
  }
}

export function getRequestEditDescriptionModalPayload(values) {
  return {
    text: getRequestEditDescriptionModalComparableValue(
      values?.[REQUEST_EDIT_DESCRIPTION_MODAL_FIELD_NAME]
    ),
  }
}

export function getRequestEditDescriptionModalValidationSchema({
  initialValues,
}) {
  return formValidationSchemaNoChanged({
    initialValues,
    isEqual: isRequestEditDescriptionModalFormFieldsEqual,
  })
}
